import { Button, Flex, Image, Link, VStack } from '@chakra-ui/react';
import React from 'react';
import { ROUTES } from '../config';
import { TextBlock } from './components/TextBlock';
import { useSession } from './hooks';
import { Navbar } from './Navbar/Navbar';
import { NavbarUnauthenticated } from './Navbar/NavbarUnauthenticated';

export const PageNotFound: React.FC = () => {
  const session = useSession();
  const isLoggedIn = session.session !== null;
  return (
    <Flex height="100%" flexDirection="column" alignItems={'center'} w="100%" bgColor={'white'}>
      <VStack
        w="100%"
        position="sticky"
        top="0px"
        zIndex={10}
        bgColor={'white'}
        borderBottomColor={'gray.100'}
        borderBottomWidth={1}>
        {isLoggedIn ? <Navbar /> : <NavbarUnauthenticated />}
      </VStack>
      <Flex maxW="100%" flexDirection="column" alignItems={'center'} textAlign={'center'} px="24px">
        <Image mt={'100px'} w={'100%'} maxW="425px" src="/assets/gfx/404.png" />
        <TextBlock weight="bold" mt={'76px'} textAlign="center" fontSize={['24px', '30px']}>
          This page could not be found.
        </TextBlock>
        <Link mx="24px" mt="30px" href={ROUTES.dashboard}>
          <Button h="60px" px={['12px', '38px']}>
            Go back to the dashboard
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
};
